import { useGetWebsiteQuery } from 'features/website/services';
import { Suspense, useEffect, useMemo } from 'react';

import { styled } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { Studio } from 'sanity';
import { createStudioConfig } from '../configuration/studioConfig';

// const Studio = lazy(() => import('sanity').then((module) => ({ default: module.Studio })));

const StudioWrapper = styled('div')({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    zIndex: 9997,
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0,
    padding: 0,
    overflow: 'auto',
    background: '#fff',
});

export default function SanityStudio() {
    const { pathname } = useLocation();
    const { websiteIdStudio } = useParams();
    const { data: websiteData } = useGetWebsiteQuery(websiteIdStudio!, {
        skip: !websiteIdStudio,
    });

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    const isSanityConfigurable = useMemo(
        () => websiteIdStudio && websiteData && websiteData.domain,
        [websiteIdStudio, websiteData],
    );

    const sanityStudioConfig = useMemo(
        () => isSanityConfigurable && createStudioConfig(pathname, websiteData!.domain),
        [isSanityConfigurable, pathname, websiteData],
    );

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <StudioWrapper>
                {isSanityConfigurable && sanityStudioConfig && (
                    <Studio key={websiteData!.domain!} config={sanityStudioConfig} />
                )}
            </StudioWrapper>
        </Suspense>
    );
}
